// Centralized translations for the Wynwood Residences landing.
// Canonical enum values (like investment_intent / preferred_experience)
// are kept in English because the backend validates against them.

export const translations = {
    en: {
        // Announcement / Banner
        "banner.text": "Limited Availability — Early Access Phase",
        "banner.wynwood": "Wynwood · Miami",

        // Navbar
        "nav.live": "Live",
        "nav.invest": "Invest",
        "nav.combo": "Combo",
        "nav.location": "Location",
        "nav.pricing": "Pricing",
        "nav.attractions": "Miami",
        "nav.amenities": "Amenities",
        "nav.admin": "Admin",
        "nav.book_tour": "Book a Tour",
        "brand.title": "WYNWOOD RESIDENCES",
        "brand.subtitle": "Miami Home Store",

        // Hero
        "hero.overline": "Wynwood · Miami · 2026",
        "hero.headline_before": "Own a High‑Performance",
        "hero.headline_highlight": "Asset",
        "hero.headline_after": "in Wynwood.",
        "hero.subhead":
            "Residential · Office · Short‑Term Rental Potential — designed for income & flexibility in Miami's fastest growing cultural district.",
        "hero.cta_tour": "Book a Private Tour",
        "hero.cta_vr": "Experience It in VR",
        "hero.micro_live": "Fully Finished",
        "hero.micro_work": "Private Office Suite",
        "hero.micro_earn": "Short‑Term Friendly",
        "hero.scroll": "Scroll",

        // Value Prop
        "vp.overline": "Live · Work · Earn",
        "vp.heading": "Three assets. One address.",
        "vp.subhead":
            "A single unit that lives, works, and earns for you — engineered for Miami's new generation of owners and investors.",
        "vp.live.overline": "Live",
        "vp.live.title": "A fully finished modern residence.",
        "vp.live.body":
            "Move into a turn‑key luxury space designed by award‑winning interiors. Every detail — from hardwoods to hardware — is already curated.",
        "vp.work.overline": "Work",
        "vp.work.title": "Your own private office suite.",
        "vp.work.body":
            "Operate your business or host clients from a dedicated workspace — inside the building, separate from your home.",
        "vp.earn.overline": "Earn",
        "vp.earn.title": "Income that works while you sleep.",
        "vp.earn.body":
            "Short‑term‑rental‑friendly concept engineered for flexible income strategies in one of Miami's highest‑demand neighborhoods.",

        // Investment Angle
        "inv.overline": "Key Investment Angle",
        "inv.heading": "A new category of real estate in Miami.",
        "inv.body_before": "This is ",
        "inv.body_highlight": "not just a condo",
        "inv.body_after":
            " — it's an income‑driven asset built for the way high‑net‑worth owners actually live, work, and invest in 2026.",
        "inv.bullet_1": "Flexible rental strategy",
        "inv.bullet_2": "Fully furnished units",
        "inv.bullet_3": "Designed for short‑term demand",
        "inv.bullet_4": "Dual‑use residential + office zoning",

        // Combo
        "combo.overline": "The Differentiator",
        "combo.heading_line1": "Own both:",
        "combo.heading_highlight": "Residence + Private Office.",
        "combo.body":
            "Maximize your asset performance with a dual‑use concept that adapts to every stage of your life.",
        "combo.badge_res": "Residence",
        "combo.badge_office": "+ Private Office",
        "combo.opt1_title": "Residential unit for living or renting.",
        "combo.opt2_title": "Private office for business or income.",
        "combo.opt_label": "Option",
        "combo.furnished_badge": "Fully Furnished",
        "combo.furnished_note":
            "Both units delivered fully furnished — residence AND office, move‑in and rent‑ready from day one.",

        // Amenities
        "amenities.overline": "Hotel‑Grade Amenities",
        "amenities.heading_line1": "Hotel‑style amenities.",
        "amenities.heading_highlight": "Top‑of‑the‑line social areas.",
        "amenities.subhead":
            "Designed as a resort — used as an asset. Every social space is engineered to wow guests from day one and keep residents coming back.",
        "amenities.pool_label": "01 · Pool & Cabanas",
        "amenities.pool_title": "Resort‑scale rooftop pool.",
        "amenities.pool_body":
            "A long lap pool surrounded by designer cabanas, chaise lounges and tropical landscaping — a permanent vacation for residents and short‑stay guests.",
        "amenities.spa_label": "02 · Wellness Pavilion",
        "amenities.spa_title": "Spa, sauna & swing garden.",
        "amenities.spa_body":
            "A wood‑and‑glass wellness pavilion with a dry sauna, hanging swings and lush landscaping — open to the sky at dusk.",
        "amenities.shower_label": "03 · Tropical Showers",
        "amenities.shower_title": "Travertine rain showers.",
        "amenities.shower_body":
            "Open‑air rain showers in travertine, framed by a jungle garden — the post‑pool ritual every guest posts about.",

        // Pricing
        "pricing.overline": "Starting Prices",
        "pricing.heading": "Your entry point into Wynwood.",
        "pricing.subhead":
            "Early‑access pricing for a new category of mixed‑use Miami real estate. Reach out for current availability and floor plans.",
        "pricing.partner_label": "In partnership with",
        "pricing.partner_copy":
            "Both properties operate under an official Airbnb partnership — structured for short‑term rental performance from day one.",
        "pricing.furnished_chip": "Fully Furnished",
        "pricing.single_label": "Single Units",
        "pricing.single_price": "From mid $500s",
        "pricing.single_sub": "Fully finished residence or private office, sold separately.",
        "pricing.combo_label": "Combo Apartment + Office",
        "pricing.combo_price": "From mid $600s",
        "pricing.combo_sub": "Dual‑use configuration. The differentiator of the project.",
        "pricing.disclaimer":
            "* Prices shown are starting points and subject to change without notice. Final pricing depends on unit, floor, view and availability.",
        "pricing.cta": "Request Detailed Pricing",

        // Short Term
        "st.overline": "Short‑Term Rental Concept",
        "st.heading": "Short‑Term Rental Friendly Concept.",
        "st.body":
            "Structured to support flexible rental strategies in a high‑demand location — so your asset keeps producing whether you're in Miami or the other side of the world.",
        "st.stat1_label": "Days of demand",
        "st.stat2_label": "Countries of visitors",
        "st.stat3_value_label": "Occupancy potential",
        "st.stat3_value": "High",
        "st.disclaimer":
            "* Subject to local regulations and building policies. Rental strategies are illustrative and not a guarantee of future performance.",

        // Location
        "loc.overline": "Wynwood · Miami",
        "loc.heading": "Located in the heart of Wynwood.",
        "loc.body":
            "One of Miami's fastest‑growing districts — where art, hospitality, and capital converge.",
        "loc.h1_title": "Tourism",
        "loc.h1_body": "One of Miami's top visitor districts year‑round.",
        "loc.h2_title": "Creative Industries",
        "loc.h2_body": "Home to galleries, studios, agencies and restaurants.",
        "loc.h3_title": "High Rental Demand",
        "loc.h3_body": "Short‑stay occupancy outperforms Miami averages.",
        "loc.address": "NW 2nd Ave · Wynwood Arts District",

        // Dual CTA
        "dcta.opt_a_label": "Option A",
        "dcta.opt_a_heading": "Schedule Your Private Visit.",
        "dcta.opt_a_body": "Meet our team at the sales gallery for a private walk‑through.",
        "dcta.opt_a_cta": "Book in‑person",
        "dcta.opt_b_label": "Option B",
        "dcta.opt_b_heading": "Experience it remotely in VR.",
        "dcta.opt_b_body":
            "Anywhere in the world — a full immersive walk‑through of the project.",
        "dcta.opt_b_cta": "Request VR tour",

        // Lead Form
        "form.overline": "Request Access",
        "form.heading": "Get floor plans, pricing & availability.",
        "form.subhead":
            "Tell us who you are and how you'd like to experience the project. A private advisor will reach out within 24 hours.",
        "form.name": "Full Name *",
        "form.name_ph": "Jane Doe",
        "form.email": "Email *",
        "form.email_ph": "you@email.com",
        "form.phone": "Phone (WhatsApp friendly) *",
        "form.phone_ph": "+1 305 555 0123",
        "form.nationality": "Nationality",
        "form.nationality_ph": "e.g. United States",
        "form.intent": "Investment Intent *",
        "form.intent_ph": "Select intent",
        "form.intent.personal": "Personal use",
        "form.intent.investment": "Investment",
        "form.intent.both": "Both",
        "form.budget": "Budget range",
        "form.budget_ph": "Select budget",
        "form.budget.o1": "Under $500K",
        "form.budget.o2": "$500K – $1M",
        "form.budget.o3": "$1M – $2M",
        "form.budget.o4": "$2M+",
        "form.timeline": "Timeline",
        "form.timeline_ph": "When would you purchase?",
        "form.timeline.o1": "Immediately",
        "form.timeline.o2": "1–3 months",
        "form.timeline.o3": "3–6 months",
        "form.timeline.o4": "Exploring",
        "form.experience": "Preferred Experience *",
        "form.experience.inperson_title": "In‑Person Visit",
        "form.experience.inperson_sub": "Sales Gallery – Miami",
        "form.experience.video_title": "Virtual Tour",
        "form.experience.video_sub": "Video call presentation",
        "form.experience.vr_title": "VR Virtual Visit",
        "form.experience.vr_sub": "Sales Gallery Miami Experience",
        "form.disclaimer":
            "By submitting, you agree to be contacted by Miami Home Store. Subject to local regulations.",
        "form.submit": "Request Full Details",
        "form.required_error": "Please complete the required fields.",
        "form.success_received": "Request received. Our team will contact you shortly.",
        "form.success_heading": "Your request is in.",
        "form.success_body":
            "A member of Miami Home Store will contact you shortly to coordinate your visit or VR tour.",

        // Final CTA
        "fcta.overline": "Early Access",
        "fcta.heading_before": "Get access to floor plans,",
        "fcta.heading_highlight": "pricing & availability.",
        "fcta.body":
            "Join the priority list. Limited units available in the early‑access phase.",
        "fcta.cta": "Request Full Details",

        // Footer
        "footer.contact": "Contact",
        "footer.invest": "Invest",
        "footer.admin": "Admin",
        "footer.copyright": "Miami Home Store · All rights reserved.",
        "footer.legal":
            "Marketing imagery is illustrative. Floor plans, finishes and features may change. Rental performance is subject to local regulations and building policies. This is not an offering where prohibited by law.",

        // VR Modal
        "vr.overline": "Virtual Experience",
        "vr.heading": "VR Tour — Coming Soon.",
        "vr.body":
            "Our immersive VR experience is launching shortly. Request early access and we'll send you the link as soon as it goes live.",
        "vr.cta": "Request VR Access",

        // WhatsApp
        "wa.label": "WhatsApp",
        "wa.prefill":
            "Hi, I'm interested in Wynwood Residences. Can you share details?",

        // Language switcher
        "lang.en": "EN",
        "lang.es": "ES",
        "lang.it": "IT",
        "lang.fr": "FR",

        // Miami Attractions
        "attractions.overline": "Tourism Powers the Asset",
        "attractions.heading_line1": "15 million visit Wynwood.",
        "attractions.heading_line2": "28.2 million visit Miami.",
        "attractions.subhead":
            "Tourism is the fuel behind Miami's short‑term rental economy — and your asset sits right at the center of the flow.",
        "attractions.stat1_label": "Annual visitors to Miami",
        "attractions.stat2_label": "Annual visitors to Wynwood",
        "attractions.wynwood_tag": "District 01",
        "attractions.wynwood_title": "Wynwood — Miami's Art & Culture District",
        "attractions.wynwood_body":
            "Street murals, rooftop bars, design studios and the creative capital of South Florida — all within walking distance.",
        "attractions.edgewater_tag": "District 02",
        "attractions.edgewater_title": "Edgewater — Bay Views & Miami Skyline",
        "attractions.edgewater_body":
            "Waterfront towers, marinas and open‑sky balconies overlooking Biscayne Bay and the downtown skyline.",
        "attractions.miamibeach_tag": "District 03",
        "attractions.miamibeach_title": "Miami Beach — World Famous Coastline",
        "attractions.miamibeach_body":
            "Art Deco, turquoise water and one of the most iconic beach strips on Earth — minutes from your door.",
        "attractions.explore": "Explore",
        "attractions.source":
            "* Source: Greater Miami Convention & Visitors Bureau tourism reports.",
    },

    es: {
        "banner.text": "Disponibilidad Limitada — Fase de Acceso Anticipado",
        "banner.wynwood": "Wynwood · Miami",

        "nav.live": "Vive",
        "nav.invest": "Invierte",
        "nav.combo": "Combo",
        "nav.location": "Ubicación",
        "nav.pricing": "Precios",
        "nav.attractions": "Miami",
        "nav.amenities": "Amenidades",
        "nav.admin": "Admin",
        "nav.book_tour": "Reserva Tour",
        "brand.title": "WYNWOOD RESIDENCES",
        "brand.subtitle": "Miami Home Store",

        "hero.overline": "Wynwood · Miami · 2026",
        "hero.headline_before": "Invierte en un",
        "hero.headline_highlight": "Activo",
        "hero.headline_after": "de Alto Rendimiento en Wynwood.",
        "hero.subhead":
            "Residencial · Oficina · Potencial de Renta Corta — diseñado para ingresos y flexibilidad en el distrito cultural de mayor crecimiento de Miami.",
        "hero.cta_tour": "Reserva Tu Tour Privado",
        "hero.cta_vr": "Vívelo en VR",
        "hero.micro_live": "Totalmente Amoblado",
        "hero.micro_work": "Oficina Privada",
        "hero.micro_earn": "Amigable con Renta Corta",
        "hero.scroll": "Desliza",

        "vp.overline": "Vive · Trabaja · Gana",
        "vp.heading": "Tres activos. Una dirección.",
        "vp.subhead":
            "Una sola unidad que vive, trabaja y genera ingresos para ti — diseñada para la nueva generación de propietarios e inversores de Miami.",
        "vp.live.overline": "Vive",
        "vp.live.title": "Una residencia moderna totalmente terminada.",
        "vp.live.body":
            "Múdate a un espacio de lujo llave en mano diseñado por interioristas premiados. Cada detalle — desde los suelos hasta los herrajes — ya está curado.",
        "vp.work.overline": "Trabaja",
        "vp.work.title": "Tu propia suite de oficina privada.",
        "vp.work.body":
            "Opera tu negocio o recibe clientes desde un espacio dedicado — dentro del edificio, separado de tu casa.",
        "vp.earn.overline": "Gana",
        "vp.earn.title": "Ingresos que trabajan mientras duermes.",
        "vp.earn.body":
            "Concepto amigable con la renta corta, diseñado para estrategias de ingresos flexibles en uno de los barrios de mayor demanda de Miami.",

        "inv.overline": "Ángulo Clave de Inversión",
        "inv.heading": "Una nueva categoría de bienes raíces en Miami.",
        "inv.body_before": "Esto ",
        "inv.body_highlight": "no es solo un condominio",
        "inv.body_after":
            " — es un activo generador de ingresos, construido para la forma en que los propietarios de alto patrimonio realmente viven, trabajan e invierten en 2026.",
        "inv.bullet_1": "Estrategia de renta flexible",
        "inv.bullet_2": "Unidades totalmente amuebladas",
        "inv.bullet_3": "Diseñado para la demanda de corto plazo",
        "inv.bullet_4": "Zonificación de doble uso: residencial + oficina",

        "combo.overline": "El Diferenciador",
        "combo.heading_line1": "Ten ambos:",
        "combo.heading_highlight": "Residencia + Oficina Privada.",
        "combo.body":
            "Maximiza el rendimiento de tu activo con un concepto de doble uso que se adapta a cada etapa de tu vida.",
        "combo.badge_res": "Residencia",
        "combo.badge_office": "+ Oficina Privada",
        "combo.opt1_title": "Unidad residencial para vivir o rentar.",
        "combo.opt2_title": "Oficina privada para negocio o ingresos.",
        "combo.opt_label": "Opción",
        "combo.furnished_badge": "Totalmente Amoblado",
        "combo.furnished_note":
            "Ambas unidades se entregan totalmente amobladas — residencia Y oficina, listas para habitar y rentar desde el primer día.",

        "amenities.overline": "Amenidades Estilo Hotel",
        "amenities.heading_line1": "Amenidades estilo hotel.",
        "amenities.heading_highlight": "Áreas sociales de primer nivel.",
        "amenities.subhead":
            "Diseñado como un resort — usado como activo. Cada espacio social está pensado para impactar a los huéspedes desde el primer día y mantener a los residentes volviendo.",
        "amenities.pool_label": "01 · Piscina y Cabañas",
        "amenities.pool_title": "Piscina en azotea a escala resort.",
        "amenities.pool_body":
            "Una piscina tipo lap larga rodeada de cabañas de diseño, camastros y paisajismo tropical — unas vacaciones permanentes para residentes y huéspedes de corta estancia.",
        "amenities.spa_label": "02 · Pabellón de Bienestar",
        "amenities.spa_title": "Spa, sauna y jardín de hamacas.",
        "amenities.spa_body":
            "Un pabellón de bienestar en madera y vidrio con sauna seca, hamacas colgantes y vegetación frondosa — abierto al cielo al atardecer.",
        "amenities.shower_label": "03 · Duchas Tropicales",
        "amenities.shower_title": "Duchas de lluvia en travertino.",
        "amenities.shower_body":
            "Duchas de lluvia al aire libre en travertino, enmarcadas por un jardín selvático — el ritual post‑piscina que cada huésped publica.",

        "pricing.overline": "Precios Desde",
        "pricing.heading": "Tu punto de entrada a Wynwood.",
        "pricing.subhead":
            "Precios de acceso anticipado para una nueva categoría de bienes raíces mixtos en Miami. Contáctanos para disponibilidad actual y planos.",
        "pricing.partner_label": "En alianza con",
        "pricing.partner_copy":
            "Ambas propiedades operan bajo una alianza oficial con Airbnb — estructuradas para generar rendimiento de renta corta desde el primer día.",
        "pricing.furnished_chip": "Totalmente Amoblado",
        "pricing.single_label": "Unidades individuales",
        "pricing.single_price": "Desde mediados de $500K",
        "pricing.single_sub":
            "Residencia u oficina privada totalmente terminada, se venden por separado.",
        "pricing.combo_label": "Apartamento + Oficina Combo",
        "pricing.combo_price": "Desde mediados de $600K",
        "pricing.combo_sub":
            "Configuración de doble uso. El diferenciador del proyecto.",
        "pricing.disclaimer":
            "* Los precios mostrados son desde y están sujetos a cambios sin previo aviso. El precio final depende de la unidad, piso, vista y disponibilidad.",
        "pricing.cta": "Solicita Precios Detallados",

        "st.overline": "Concepto de Renta Corta",
        "st.heading": "Concepto Amigable con la Renta Corta.",
        "st.body":
            "Estructurado para soportar estrategias de renta flexibles en una ubicación de alta demanda — para que tu activo siga produciendo estés en Miami o al otro lado del mundo.",
        "st.stat1_label": "Días de demanda",
        "st.stat2_label": "Países visitantes",
        "st.stat3_value_label": "Potencial de ocupación",
        "st.stat3_value": "Alto",
        "st.disclaimer":
            "* Sujeto a regulaciones locales y políticas del edificio. Las estrategias de renta son ilustrativas y no garantizan rendimientos futuros.",

        "loc.overline": "Wynwood · Miami",
        "loc.heading": "Ubicado en el corazón de Wynwood.",
        "loc.body":
            "Uno de los distritos de mayor crecimiento de Miami — donde el arte, la hospitalidad y el capital convergen.",
        "loc.h1_title": "Turismo",
        "loc.h1_body": "Uno de los distritos más visitados de Miami todo el año.",
        "loc.h2_title": "Industrias Creativas",
        "loc.h2_body": "Hogar de galerías, estudios, agencias y restaurantes.",
        "loc.h3_title": "Alta Demanda de Renta",
        "loc.h3_body": "La ocupación de estancias cortas supera el promedio de Miami.",
        "loc.address": "NW 2nd Ave · Wynwood Arts District",

        "dcta.opt_a_label": "Opción A",
        "dcta.opt_a_heading": "Agenda Tu Visita Privada.",
        "dcta.opt_a_body":
            "Conoce a nuestro equipo en la galería de ventas para un recorrido privado.",
        "dcta.opt_a_cta": "Reserva presencial",
        "dcta.opt_b_label": "Opción B",
        "dcta.opt_b_heading": "Vívelo de forma remota en VR.",
        "dcta.opt_b_body":
            "Desde cualquier parte del mundo — un recorrido inmersivo completo del proyecto.",
        "dcta.opt_b_cta": "Solicita tour VR",

        "form.overline": "Solicita Acceso",
        "form.heading": "Obtén planos, precios y disponibilidad.",
        "form.subhead":
            "Cuéntanos quién eres y cómo te gustaría vivir el proyecto. Un asesor privado te contactará en las próximas 24 horas.",
        "form.name": "Nombre Completo *",
        "form.name_ph": "María Pérez",
        "form.email": "Email *",
        "form.email_ph": "tu@email.com",
        "form.phone": "Teléfono (WhatsApp friendly) *",
        "form.phone_ph": "+1 305 555 0123",
        "form.nationality": "Nacionalidad",
        "form.nationality_ph": "ej. España",
        "form.intent": "Intención de Inversión *",
        "form.intent_ph": "Selecciona intención",
        "form.intent.personal": "Uso personal",
        "form.intent.investment": "Inversión",
        "form.intent.both": "Ambos",
        "form.budget": "Rango de presupuesto",
        "form.budget_ph": "Selecciona presupuesto",
        "form.budget.o1": "Menos de $500K",
        "form.budget.o2": "$500K – $1M",
        "form.budget.o3": "$1M – $2M",
        "form.budget.o4": "$2M+",
        "form.timeline": "Cronograma",
        "form.timeline_ph": "¿Cuándo comprarías?",
        "form.timeline.o1": "Inmediatamente",
        "form.timeline.o2": "1–3 meses",
        "form.timeline.o3": "3–6 meses",
        "form.timeline.o4": "Explorando",
        "form.experience": "Experiencia Preferida *",
        "form.experience.inperson_title": "Visita Presencial",
        "form.experience.inperson_sub": "Sales Gallery – Miami",
        "form.experience.video_title": "Tour Virtual",
        "form.experience.video_sub": "Presentación por videollamada",
        "form.experience.vr_title": "Visita Virtual en VR",
        "form.experience.vr_sub": "Sales Gallery Miami Experience",
        "form.disclaimer":
            "Al enviar, aceptas ser contactado por Miami Home Store. Sujeto a regulaciones locales.",
        "form.submit": "Solicita Todos los Detalles",
        "form.required_error": "Por favor completa los campos obligatorios.",
        "form.success_received":
            "Solicitud recibida. Nuestro equipo te contactará en breve.",
        "form.success_heading": "Tu solicitud está en camino.",
        "form.success_body":
            "Un miembro de Miami Home Store te contactará en breve para coordinar tu visita o tour VR.",

        "fcta.overline": "Acceso Anticipado",
        "fcta.heading_before": "Obtén acceso a planos,",
        "fcta.heading_highlight": "precios y disponibilidad.",
        "fcta.body":
            "Únete a la lista prioritaria. Unidades limitadas disponibles en la fase de acceso anticipado.",
        "fcta.cta": "Solicita Todos los Detalles",

        "footer.contact": "Contacto",
        "footer.invest": "Invierte",
        "footer.admin": "Admin",
        "footer.copyright": "Miami Home Store · Todos los derechos reservados.",
        "footer.legal":
            "Las imágenes son ilustrativas. Planos, acabados y características pueden cambiar. El rendimiento de renta está sujeto a regulaciones locales y políticas del edificio. Esto no constituye una oferta donde esté prohibido por ley.",

        "vr.overline": "Experiencia Virtual",
        "vr.heading": "Tour VR — Próximamente.",
        "vr.body":
            "Nuestra experiencia inmersiva de VR se lanza próximamente. Solicita acceso anticipado y te enviaremos el enlace tan pronto esté disponible.",
        "vr.cta": "Solicita Acceso VR",

        "wa.label": "WhatsApp",
        "wa.prefill":
            "Hola, estoy interesado/a en Wynwood Residences. ¿Me podrías compartir detalles?",

        "lang.en": "EN",
        "lang.es": "ES",
        "lang.it": "IT",
        "lang.fr": "FR",

        "attractions.overline": "El turismo impulsa el activo",
        "attractions.heading_line1": "15 millones visitan Wynwood.",
        "attractions.heading_line2": "28.2 millones visitan Miami.",
        "attractions.subhead":
            "El turismo es el combustible detrás de la economía de renta corta de Miami — y tu activo está justo en el centro del flujo.",
        "attractions.stat1_label": "Visitantes anuales a Miami",
        "attractions.stat2_label": "Visitantes anuales a Wynwood",
        "attractions.wynwood_tag": "Distrito 01",
        "attractions.wynwood_title": "Wynwood — El Distrito de Arte y Cultura de Miami",
        "attractions.wynwood_body":
            "Murales callejeros, azoteas, estudios de diseño y la capital creativa del sur de Florida — todo a pie.",
        "attractions.edgewater_tag": "Distrito 02",
        "attractions.edgewater_title": "Edgewater — Vistas a la Bahía y Skyline de Miami",
        "attractions.edgewater_body":
            "Torres frente al mar, marinas y balcones al aire libre con vistas a Biscayne Bay y al skyline del downtown.",
        "attractions.miamibeach_tag": "Distrito 03",
        "attractions.miamibeach_title": "Miami Beach — Costa de Fama Mundial",
        "attractions.miamibeach_body":
            "Art Déco, aguas turquesa y una de las franjas costeras más icónicas del mundo — a minutos de tu puerta.",
        "attractions.explore": "Explorar",
        "attractions.source":
            "* Fuente: reportes de turismo del Greater Miami Convention & Visitors Bureau.",
    },

    it: {
        "banner.text": "Disponibilità Limitata — Fase di Accesso Anticipato",
        "banner.wynwood": "Wynwood · Miami",

        "nav.live": "Vivi",
        "nav.invest": "Investi",
        "nav.combo": "Combo",
        "nav.location": "Posizione",
        "nav.pricing": "Prezzi",
        "nav.attractions": "Miami",
        "nav.amenities": "Servizi",
        "nav.admin": "Admin",
        "nav.book_tour": "Prenota Tour",
        "brand.title": "WYNWOOD RESIDENCES",
        "brand.subtitle": "Miami Home Store",

        "hero.overline": "Wynwood · Miami · 2026",
        "hero.headline_before": "Possiedi un",
        "hero.headline_highlight": "Asset",
        "hero.headline_after": "ad Alte Prestazioni a Wynwood.",
        "hero.subhead":
            "Residenziale · Ufficio · Potenziale di Affitto a Breve Termine — progettato per rendita e flessibilità nel distretto culturale a più rapida crescita di Miami.",
        "hero.cta_tour": "Prenota un Tour Privato",
        "hero.cta_vr": "Vivilo in VR",
        "hero.micro_live": "Completamente Arredato",
        "hero.micro_work": "Ufficio Privato",
        "hero.micro_earn": "Compatibile con Affitti Brevi",
        "hero.scroll": "Scorri",

        "vp.overline": "Vivi · Lavora · Guadagna",
        "vp.heading": "Tre asset. Un unico indirizzo.",
        "vp.subhead":
            "Una singola unità che vive, lavora e genera reddito per te — pensata per la nuova generazione di proprietari e investitori di Miami.",
        "vp.live.overline": "Vivi",
        "vp.live.title": "Una residenza moderna completamente arredata.",
        "vp.live.body":
            "Trasferisciti in uno spazio di lusso chiavi in mano, progettato da interior designer pluripremiati. Ogni dettaglio — dai pavimenti alle maniglie — è già curato.",
        "vp.work.overline": "Lavora",
        "vp.work.title": "Il tuo ufficio privato.",
        "vp.work.body":
            "Gestisci la tua attività o ricevi clienti in uno spazio dedicato — all'interno dell'edificio, separato da casa.",
        "vp.earn.overline": "Guadagna",
        "vp.earn.title": "Rendita che lavora mentre dormi.",
        "vp.earn.body":
            "Concept compatibile con l'affitto a breve termine, progettato per strategie di reddito flessibili in uno dei quartieri a più alta domanda di Miami.",

        "inv.overline": "Angolo di Investimento Chiave",
        "inv.heading": "Una nuova categoria di real estate a Miami.",
        "inv.body_before": "Questo ",
        "inv.body_highlight": "non è solo un condominio",
        "inv.body_after":
            " — è un asset generatore di reddito, costruito per il modo in cui i proprietari di alto patrimonio vivono, lavorano e investono davvero nel 2026.",
        "inv.bullet_1": "Strategia di affitto flessibile",
        "inv.bullet_2": "Unità completamente arredate",
        "inv.bullet_3": "Progettato per la domanda a breve termine",
        "inv.bullet_4": "Zonizzazione mista: residenziale + ufficio",

        "combo.overline": "Il Differenziatore",
        "combo.heading_line1": "Possiedi entrambi:",
        "combo.heading_highlight": "Residenza + Ufficio Privato.",
        "combo.body":
            "Massimizza il rendimento del tuo asset con un concept a doppio uso che si adatta a ogni fase della tua vita.",
        "combo.badge_res": "Residenza",
        "combo.badge_office": "+ Ufficio Privato",
        "combo.opt1_title": "Unità residenziale per vivere o affittare.",
        "combo.opt2_title": "Ufficio privato per attività o reddito.",
        "combo.opt_label": "Opzione",
        "combo.furnished_badge": "Completamente Arredato",
        "combo.furnished_note":
            "Entrambe le unità consegnate completamente arredate — residenza E ufficio, pronte per abitare e affittare dal primo giorno.",

        "amenities.overline": "Servizi da Hotel Premium",
        "amenities.heading_line1": "Servizi in stile hotel.",
        "amenities.heading_highlight": "Aree sociali di altissimo livello.",
        "amenities.subhead":
            "Progettato come un resort — usato come asset. Ogni spazio sociale è pensato per stupire gli ospiti dal primo giorno e far tornare i residenti.",
        "amenities.pool_label": "01 · Piscina & Cabanas",
        "amenities.pool_title": "Piscina sul tetto in scala resort.",
        "amenities.pool_body":
            "Una piscina lap lunga circondata da cabanas di design, chaise lounge e vegetazione tropicale — vacanze permanenti per residenti e ospiti.",
        "amenities.spa_label": "02 · Padiglione Wellness",
        "amenities.spa_title": "Spa, sauna e giardino di altalene.",
        "amenities.spa_body":
            "Un padiglione wellness in legno e vetro con sauna secca, altalene sospese e paesaggistica rigogliosa — aperto al cielo al tramonto.",
        "amenities.shower_label": "03 · Docce Tropicali",
        "amenities.shower_title": "Docce a pioggia in travertino.",
        "amenities.shower_body":
            "Docce a pioggia all'aperto in travertino, incorniciate da un giardino tropicale — il rituale post-piscina che ogni ospite condivide.",

        "pricing.overline": "Prezzi da",
        "pricing.heading": "Il tuo punto d'ingresso a Wynwood.",
        "pricing.subhead":
            "Prezzi di accesso anticipato per una nuova categoria di real estate misto a Miami. Contattaci per disponibilità attuale e planimetrie.",
        "pricing.partner_label": "In partnership con",
        "pricing.partner_copy":
            "Entrambe le proprietà operano sotto una partnership ufficiale con Airbnb — strutturate per performance di affitto a breve termine fin dal primo giorno.",
        "pricing.furnished_chip": "Completamente Arredato",
        "pricing.single_label": "Unità Singole",
        "pricing.single_price": "Da metà $500K",
        "pricing.single_sub":
            "Residenza o ufficio privato completamente arredato, venduti separatamente.",
        "pricing.combo_label": "Combo Appartamento + Ufficio",
        "pricing.combo_price": "Da metà $600K",
        "pricing.combo_sub":
            "Configurazione a doppio uso. Il differenziatore del progetto.",
        "pricing.disclaimer":
            "* I prezzi mostrati sono di partenza e soggetti a modifiche senza preavviso. Il prezzo finale dipende da unità, piano, vista e disponibilità.",
        "pricing.cta": "Richiedi Prezzi Dettagliati",

        "st.overline": "Concetto di Affitto Breve",
        "st.heading": "Concept Compatibile con l'Affitto Breve.",
        "st.body":
            "Strutturato per supportare strategie di affitto flessibili in una location ad alta domanda — così il tuo asset continua a produrre che tu sia a Miami o dall'altra parte del mondo.",
        "st.stat1_label": "Giorni di domanda",
        "st.stat2_label": "Paesi dei visitatori",
        "st.stat3_value_label": "Potenziale di occupazione",
        "st.stat3_value": "Alto",
        "st.disclaimer":
            "* Soggetto a normative locali e politiche dell'edificio. Le strategie di affitto sono illustrative e non garantiscono rendimenti futuri.",

        "loc.overline": "Wynwood · Miami",
        "loc.heading": "Nel cuore di Wynwood.",
        "loc.body":
            "Uno dei distretti a più rapida crescita di Miami — dove arte, ospitalità e capitale convergono.",
        "loc.h1_title": "Turismo",
        "loc.h1_body": "Uno dei distretti più visitati di Miami tutto l'anno.",
        "loc.h2_title": "Industrie Creative",
        "loc.h2_body": "Casa di gallerie, studi, agenzie e ristoranti.",
        "loc.h3_title": "Alta Domanda di Affitto",
        "loc.h3_body": "L'occupazione di soggiorni brevi supera la media di Miami.",
        "loc.address": "NW 2nd Ave · Wynwood Arts District",

        "dcta.opt_a_label": "Opzione A",
        "dcta.opt_a_heading": "Prenota la Tua Visita Privata.",
        "dcta.opt_a_body":
            "Incontra il nostro team nella sales gallery per un tour privato.",
        "dcta.opt_a_cta": "Prenota di persona",
        "dcta.opt_b_label": "Opzione B",
        "dcta.opt_b_heading": "Vivilo da remoto in VR.",
        "dcta.opt_b_body":
            "Da qualunque parte del mondo — un tour immersivo completo del progetto.",
        "dcta.opt_b_cta": "Richiedi tour VR",

        "form.overline": "Richiedi Accesso",
        "form.heading": "Ottieni planimetrie, prezzi e disponibilità.",
        "form.subhead":
            "Dicci chi sei e come vuoi vivere il progetto. Un consulente privato ti contatterà entro 24 ore.",
        "form.name": "Nome Completo *",
        "form.name_ph": "Mario Rossi",
        "form.email": "Email *",
        "form.email_ph": "tu@email.com",
        "form.phone": "Telefono (WhatsApp friendly) *",
        "form.phone_ph": "+1 305 555 0123",
        "form.nationality": "Nazionalità",
        "form.nationality_ph": "es. Italia",
        "form.intent": "Intento di Investimento *",
        "form.intent_ph": "Seleziona intento",
        "form.intent.personal": "Uso personale",
        "form.intent.investment": "Investimento",
        "form.intent.both": "Entrambi",
        "form.budget": "Fascia di budget",
        "form.budget_ph": "Seleziona budget",
        "form.budget.o1": "Meno di $500K",
        "form.budget.o2": "$500K – $1M",
        "form.budget.o3": "$1M – $2M",
        "form.budget.o4": "$2M+",
        "form.timeline": "Tempistica",
        "form.timeline_ph": "Quando compreresti?",
        "form.timeline.o1": "Immediatamente",
        "form.timeline.o2": "1–3 mesi",
        "form.timeline.o3": "3–6 mesi",
        "form.timeline.o4": "Sto esplorando",
        "form.experience": "Esperienza Preferita *",
        "form.experience.inperson_title": "Visita di Persona",
        "form.experience.inperson_sub": "Sales Gallery – Miami",
        "form.experience.video_title": "Tour Virtuale",
        "form.experience.video_sub": "Presentazione in videochiamata",
        "form.experience.vr_title": "Visita Virtuale VR",
        "form.experience.vr_sub": "Sales Gallery Miami Experience",
        "form.disclaimer":
            "Inviando, accetti di essere contattato da Miami Home Store. Soggetto a normative locali.",
        "form.submit": "Richiedi Tutti i Dettagli",
        "form.required_error": "Per favore completa i campi obbligatori.",
        "form.success_received":
            "Richiesta ricevuta. Il nostro team ti contatterà a breve.",
        "form.success_heading": "La tua richiesta è in arrivo.",
        "form.success_body":
            "Un membro di Miami Home Store ti contatterà a breve per coordinare la tua visita o tour VR.",

        "fcta.overline": "Accesso Anticipato",
        "fcta.heading_before": "Ottieni accesso a planimetrie,",
        "fcta.heading_highlight": "prezzi e disponibilità.",
        "fcta.body":
            "Unisciti alla lista prioritaria. Unità limitate disponibili nella fase di accesso anticipato.",
        "fcta.cta": "Richiedi Tutti i Dettagli",

        "footer.contact": "Contatti",
        "footer.invest": "Investi",
        "footer.admin": "Admin",
        "footer.copyright": "Miami Home Store · Tutti i diritti riservati.",
        "footer.legal":
            "Le immagini sono illustrative. Planimetrie, finiture e caratteristiche possono cambiare. Il rendimento di affitto è soggetto a normative locali e politiche dell'edificio. Questa non costituisce un'offerta ove vietato dalla legge.",

        "vr.overline": "Esperienza Virtuale",
        "vr.heading": "Tour VR — Prossimamente.",
        "vr.body":
            "La nostra esperienza immersiva VR arriverà a breve. Richiedi l'accesso anticipato e ti invieremo il link non appena sarà disponibile.",
        "vr.cta": "Richiedi Accesso VR",

        "wa.label": "WhatsApp",
        "wa.prefill":
            "Ciao, sono interessato/a a Wynwood Residences. Potresti condividere i dettagli?",

        "lang.en": "EN",
        "lang.es": "ES",
        "lang.it": "IT",
        "lang.fr": "FR",

        "attractions.overline": "Il Turismo Alimenta l'Asset",
        "attractions.heading_line1": "15 milioni visitano Wynwood.",
        "attractions.heading_line2": "28.2 milioni visitano Miami.",
        "attractions.subhead":
            "Il turismo è il carburante dietro l'economia degli affitti brevi di Miami — e il tuo asset si trova proprio al centro del flusso.",
        "attractions.stat1_label": "Visitatori annuali a Miami",
        "attractions.stat2_label": "Visitatori annuali a Wynwood",
        "attractions.wynwood_tag": "Distretto 01",
        "attractions.wynwood_title": "Wynwood — Il Distretto di Arte e Cultura di Miami",
        "attractions.wynwood_body":
            "Murales, rooftop bar, studi di design e la capitale creativa del sud della Florida — tutto a piedi.",
        "attractions.edgewater_tag": "Distretto 02",
        "attractions.edgewater_title": "Edgewater — Vista Baia e Skyline di Miami",
        "attractions.edgewater_body":
            "Torri sul lungomare, marine e balconi all'aperto con vista su Biscayne Bay e lo skyline del downtown.",
        "attractions.miamibeach_tag": "Distretto 03",
        "attractions.miamibeach_title": "Miami Beach — Costa di Fama Mondiale",
        "attractions.miamibeach_body":
            "Art Déco, acque turchesi e una delle fasce costiere più iconiche al mondo — a pochi minuti da casa.",
        "attractions.explore": "Esplora",
        "attractions.source":
            "* Fonte: report di turismo del Greater Miami Convention & Visitors Bureau.",
    },

    fr: {
        "banner.text": "Disponibilité Limitée — Phase d'Accès Anticipé",
        "banner.wynwood": "Wynwood · Miami",

        "nav.live": "Vivre",
        "nav.invest": "Investir",
        "nav.combo": "Combo",
        "nav.location": "Localisation",
        "nav.pricing": "Prix",
        "nav.attractions": "Miami",
        "nav.amenities": "Prestations",
        "nav.admin": "Admin",
        "nav.book_tour": "Réserver",
        "brand.title": "WYNWOOD RESIDENCES",
        "brand.subtitle": "Miami Home Store",

        "hero.overline": "Wynwood · Miami · 2026",
        "hero.headline_before": "Possédez un",
        "hero.headline_highlight": "Actif",
        "hero.headline_after": "Haute Performance à Wynwood.",
        "hero.subhead":
            "Résidentiel · Bureau · Potentiel Location Courte Durée — conçu pour les revenus et la flexibilité dans le quartier culturel à la croissance la plus rapide de Miami.",
        "hero.cta_tour": "Réservez une Visite Privée",
        "hero.cta_vr": "Découvrez en VR",
        "hero.micro_live": "Entièrement Meublé",
        "hero.micro_work": "Bureau Privé",
        "hero.micro_earn": "Compatible Location Courte",
        "hero.scroll": "Défiler",

        "vp.overline": "Vivre · Travailler · Gagner",
        "vp.heading": "Trois actifs. Une seule adresse.",
        "vp.subhead":
            "Une seule unité qui vit, travaille et génère des revenus pour vous — conçue pour la nouvelle génération de propriétaires et d'investisseurs à Miami.",
        "vp.live.overline": "Vivre",
        "vp.live.title": "Une résidence moderne entièrement meublée.",
        "vp.live.body":
            "Emménagez dans un espace de luxe clé en main conçu par des architectes d'intérieur primés. Chaque détail — des parquets aux poignées — est déjà sélectionné.",
        "vp.work.overline": "Travailler",
        "vp.work.title": "Votre propre suite bureau privé.",
        "vp.work.body":
            "Gérez votre activité ou recevez vos clients dans un espace dédié — dans l'immeuble, séparé de votre domicile.",
        "vp.earn.overline": "Gagner",
        "vp.earn.title": "Des revenus qui travaillent pendant que vous dormez.",
        "vp.earn.body":
            "Concept compatible location courte durée, conçu pour des stratégies de revenus flexibles dans l'un des quartiers les plus demandés de Miami.",

        "inv.overline": "Angle Clé d'Investissement",
        "inv.heading": "Une nouvelle catégorie d'immobilier à Miami.",
        "inv.body_before": "Ce ",
        "inv.body_highlight": "n'est pas qu'un condo",
        "inv.body_after":
            " — c'est un actif générateur de revenus, conçu pour la façon dont les propriétaires fortunés vivent, travaillent et investissent réellement en 2026.",
        "inv.bullet_1": "Stratégie de location flexible",
        "inv.bullet_2": "Unités entièrement meublées",
        "inv.bullet_3": "Conçu pour la demande courte durée",
        "inv.bullet_4": "Zonage double usage : résidentiel + bureau",

        "combo.overline": "Le Différenciateur",
        "combo.heading_line1": "Possédez les deux :",
        "combo.heading_highlight": "Résidence + Bureau Privé.",
        "combo.body":
            "Maximisez la performance de votre actif avec un concept double usage qui s'adapte à chaque étape de votre vie.",
        "combo.badge_res": "Résidence",
        "combo.badge_office": "+ Bureau Privé",
        "combo.opt1_title": "Unité résidentielle pour vivre ou louer.",
        "combo.opt2_title": "Bureau privé pour activité ou revenus.",
        "combo.opt_label": "Option",
        "combo.furnished_badge": "Entièrement Meublé",
        "combo.furnished_note":
            "Les deux unités livrées entièrement meublées — résidence ET bureau, prêtes à emménager et à louer dès le premier jour.",

        "amenities.overline": "Prestations Hôtelières Premium",
        "amenities.heading_line1": "Prestations de style hôtelier.",
        "amenities.heading_highlight": "Espaces sociaux haut de gamme.",
        "amenities.subhead":
            "Conçu comme un resort — utilisé comme un actif. Chaque espace social est pensé pour impressionner les invités dès le premier jour et faire revenir les résidents.",
        "amenities.pool_label": "01 · Piscine & Cabanas",
        "amenities.pool_title": "Piscine sur toit à l'échelle d'un resort.",
        "amenities.pool_body":
            "Une longue piscine à longueurs entourée de cabanas design, de transats et de végétation tropicale — des vacances permanentes pour résidents et locataires.",
        "amenities.spa_label": "02 · Pavillon Bien-être",
        "amenities.spa_title": "Spa, sauna et jardin de balançoires.",
        "amenities.spa_body":
            "Un pavillon de bien-être en bois et verre avec sauna sec, balançoires suspendues et végétation luxuriante — ouvert sur le ciel au crépuscule.",
        "amenities.shower_label": "03 · Douches Tropicales",
        "amenities.shower_title": "Douches à pluie en travertin.",
        "amenities.shower_body":
            "Douches à pluie en plein air en travertin, encadrées par un jardin tropical — le rituel post-piscine que chaque invité partage.",

        "pricing.overline": "Prix à Partir de",
        "pricing.heading": "Votre point d'entrée à Wynwood.",
        "pricing.subhead":
            "Tarifs d'accès anticipé pour une nouvelle catégorie d'immobilier mixte à Miami. Contactez-nous pour la disponibilité actuelle et les plans.",
        "pricing.partner_label": "En partenariat avec",
        "pricing.partner_copy":
            "Les deux propriétés opèrent sous un partenariat officiel avec Airbnb — structurées pour la performance en location courte durée dès le premier jour.",
        "pricing.furnished_chip": "Entièrement Meublé",
        "pricing.single_label": "Unités Individuelles",
        "pricing.single_price": "À partir de $500K et plus",
        "pricing.single_sub":
            "Résidence ou bureau privé entièrement meublé, vendus séparément.",
        "pricing.combo_label": "Combo Appartement + Bureau",
        "pricing.combo_price": "À partir de $600K et plus",
        "pricing.combo_sub":
            "Configuration double usage. Le différenciateur du projet.",
        "pricing.disclaimer":
            "* Les prix affichés sont des points de départ et sujets à modification sans préavis. Le prix final dépend de l'unité, de l'étage, de la vue et de la disponibilité.",
        "pricing.cta": "Demandez les Prix Détaillés",

        "st.overline": "Concept Location Courte",
        "st.heading": "Concept Compatible Location Courte Durée.",
        "st.body":
            "Structuré pour soutenir des stratégies de location flexibles dans un emplacement à forte demande — pour que votre actif continue à produire que vous soyez à Miami ou à l'autre bout du monde.",
        "st.stat1_label": "Jours de demande",
        "st.stat2_label": "Pays des visiteurs",
        "st.stat3_value_label": "Potentiel d'occupation",
        "st.stat3_value": "Élevé",
        "st.disclaimer":
            "* Soumis aux réglementations locales et aux politiques de l'immeuble. Les stratégies de location sont illustratives et ne garantissent pas les rendements futurs.",

        "loc.overline": "Wynwood · Miami",
        "loc.heading": "Au cœur de Wynwood.",
        "loc.body":
            "L'un des quartiers à la croissance la plus rapide de Miami — où l'art, l'hospitalité et le capital convergent.",
        "loc.h1_title": "Tourisme",
        "loc.h1_body": "L'un des quartiers les plus visités de Miami toute l'année.",
        "loc.h2_title": "Industries Créatives",
        "loc.h2_body": "Maison de galeries, studios, agences et restaurants.",
        "loc.h3_title": "Forte Demande Locative",
        "loc.h3_body": "L'occupation en séjours courts dépasse la moyenne de Miami.",
        "loc.address": "NW 2nd Ave · Wynwood Arts District",

        "dcta.opt_a_label": "Option A",
        "dcta.opt_a_heading": "Planifiez Votre Visite Privée.",
        "dcta.opt_a_body":
            "Rencontrez notre équipe au sales gallery pour une visite privée.",
        "dcta.opt_a_cta": "Réserver en personne",
        "dcta.opt_b_label": "Option B",
        "dcta.opt_b_heading": "Vivez-le à distance en VR.",
        "dcta.opt_b_body":
            "Où que vous soyez dans le monde — une visite immersive complète du projet.",
        "dcta.opt_b_cta": "Demander le tour VR",

        "form.overline": "Demander l'Accès",
        "form.heading": "Obtenez plans, prix et disponibilité.",
        "form.subhead":
            "Dites-nous qui vous êtes et comment vous souhaitez vivre le projet. Un conseiller privé vous contactera sous 24 heures.",
        "form.name": "Nom Complet *",
        "form.name_ph": "Jean Dupont",
        "form.email": "Email *",
        "form.email_ph": "vous@email.com",
        "form.phone": "Téléphone (WhatsApp friendly) *",
        "form.phone_ph": "+1 305 555 0123",
        "form.nationality": "Nationalité",
        "form.nationality_ph": "ex. France",
        "form.intent": "Intention d'Investissement *",
        "form.intent_ph": "Sélectionner l'intention",
        "form.intent.personal": "Usage personnel",
        "form.intent.investment": "Investissement",
        "form.intent.both": "Les deux",
        "form.budget": "Fourchette de budget",
        "form.budget_ph": "Sélectionner un budget",
        "form.budget.o1": "Moins de $500K",
        "form.budget.o2": "$500K – $1M",
        "form.budget.o3": "$1M – $2M",
        "form.budget.o4": "$2M+",
        "form.timeline": "Calendrier",
        "form.timeline_ph": "Quand achèteriez-vous ?",
        "form.timeline.o1": "Immédiatement",
        "form.timeline.o2": "1–3 mois",
        "form.timeline.o3": "3–6 mois",
        "form.timeline.o4": "Je prospecte",
        "form.experience": "Expérience Préférée *",
        "form.experience.inperson_title": "Visite en Personne",
        "form.experience.inperson_sub": "Sales Gallery – Miami",
        "form.experience.video_title": "Tour Virtuel",
        "form.experience.video_sub": "Présentation en visioconférence",
        "form.experience.vr_title": "Visite Virtuelle en VR",
        "form.experience.vr_sub": "Sales Gallery Miami Experience",
        "form.disclaimer":
            "En soumettant, vous acceptez d'être contacté par Miami Home Store. Soumis aux réglementations locales.",
        "form.submit": "Demander Tous les Détails",
        "form.required_error": "Veuillez compléter les champs obligatoires.",
        "form.success_received":
            "Demande reçue. Notre équipe vous contactera sous peu.",
        "form.success_heading": "Votre demande est en route.",
        "form.success_body":
            "Un membre de Miami Home Store vous contactera sous peu pour coordonner votre visite ou tour VR.",

        "fcta.overline": "Accès Anticipé",
        "fcta.heading_before": "Obtenez l'accès aux plans,",
        "fcta.heading_highlight": "prix et disponibilité.",
        "fcta.body":
            "Rejoignez la liste prioritaire. Unités limitées disponibles dans la phase d'accès anticipé.",
        "fcta.cta": "Demander Tous les Détails",

        "footer.contact": "Contact",
        "footer.invest": "Investir",
        "footer.admin": "Admin",
        "footer.copyright": "Miami Home Store · Tous droits réservés.",
        "footer.legal":
            "Les images sont illustratives. Plans, finitions et caractéristiques peuvent changer. La performance locative est soumise aux réglementations locales et politiques de l'immeuble. Ceci ne constitue pas une offre là où la loi l'interdit.",

        "vr.overline": "Expérience Virtuelle",
        "vr.heading": "Tour VR — Bientôt Disponible.",
        "vr.body":
            "Notre expérience VR immersive arrive bientôt. Demandez l'accès anticipé et nous vous enverrons le lien dès qu'il sera disponible.",
        "vr.cta": "Demander l'Accès VR",

        "wa.label": "WhatsApp",
        "wa.prefill":
            "Bonjour, je suis intéressé(e) par Wynwood Residences. Pourriez-vous partager les détails ?",

        "lang.en": "EN",
        "lang.es": "ES",
        "lang.it": "IT",
        "lang.fr": "FR",

        "attractions.overline": "Le Tourisme Alimente l'Actif",
        "attractions.heading_line1": "15 millions visitent Wynwood.",
        "attractions.heading_line2": "28.2 millions visitent Miami.",
        "attractions.subhead":
            "Le tourisme est le carburant de l'économie de location courte durée de Miami — et votre actif se trouve au cœur du flux.",
        "attractions.stat1_label": "Visiteurs annuels à Miami",
        "attractions.stat2_label": "Visiteurs annuels à Wynwood",
        "attractions.wynwood_tag": "Quartier 01",
        "attractions.wynwood_title": "Wynwood — Le Quartier Art & Culture de Miami",
        "attractions.wynwood_body":
            "Fresques murales, rooftop bars, studios de design et la capitale créative du sud de la Floride — tout à pied.",
        "attractions.edgewater_tag": "Quartier 02",
        "attractions.edgewater_title": "Edgewater — Vue sur la Baie et le Skyline de Miami",
        "attractions.edgewater_body":
            "Tours en bord de mer, marinas et balcons à ciel ouvert avec vue sur Biscayne Bay et le skyline du downtown.",
        "attractions.miamibeach_tag": "Quartier 03",
        "attractions.miamibeach_title": "Miami Beach — Côte de Renommée Mondiale",
        "attractions.miamibeach_body":
            "Art Déco, eaux turquoise et l'une des bandes côtières les plus iconiques au monde — à quelques minutes de chez vous.",
        "attractions.explore": "Explorer",
        "attractions.source":
            "* Source : rapports de tourisme du Greater Miami Convention & Visitors Bureau.",
    },
};

// Canonical backend values (NEVER translated — sent as-is)
export const EXPERIENCE_VALUES = {
    inperson: "In-Person Visit (Sales Gallery – Miami)",
    video: "Virtual Tour (Video Call Presentation)",
    vr: "VR Virtual Visit (Sales Gallery Miami Experience)",
};
